import { useAuth } from '@auth/useAuth'
import AnonPaths from '@globals/paths/anon'
import { register503Listener, unauthenticatedListener } from '@kudos/http-client'
import RouteLoading from '@shared/routing/RouteLoading'
import { useEffect, useRef } from 'react'
import { Outlet, useNavigate } from 'react-router'
import RootLayout from '../layouts/RootLayout'

export const AwaitAuth = () => {
  const { isAuthenticated, isLoading, initializeFromStorage, clearAuth, isTenantScope } = useAuth()
  const hasInitialized = useRef<boolean>(false)
  const tenantScopeRef = useRef<boolean>(isTenantScope)
  const navigate = useNavigate()

  useEffect(() => {
    tenantScopeRef.current = isTenantScope
  }, [isTenantScope])

  useEffect(() => {
    if (!hasInitialized.current) {
      initializeFromStorage()
      // Register listener to detect 401s and clear the auth
      // Only clear auth if we are in tenant scope; ignore 401s during user-scope (multi-tenant selection)
      unauthenticatedListener(() => {
        if (tenantScopeRef.current) {
          clearAuth()
        }
      })
      // Register listener to detect 503 (maintenance) and redirect to maintenance page
      register503Listener(() => navigate(AnonPaths.maintenance()))
    }
    hasInitialized.current = true
  }, [])

  if (isLoading) {
    return <RouteLoading />
  }

  return (
    <RootLayout isAuthenticated={isAuthenticated} isTenantScope={isTenantScope}>
      <Outlet />
    </RootLayout>
  )
}
